<template>
  <flex
    justify="between"
    align="center"
    class="type-list">
    <flex
      v-for="(item, index) in typeList"
      :key="index"
      direction="column"
      justify="center"
      align="center"
      class="type-item"
      @click="selectType(item)">
      <i
        :class="`iconfont icon-${item.icon}`"
        class="type-icon"/>
      <span class="type-name">{{ item.name }}</span>
    </flex>
  </flex>
</template>

<script>
export default {
  data () {
    return {
      typeList: [
        {
          name: '领导关怀',
          value: '领导关怀',
          icon: 'lingdaoguanhuai'
        },
        {
          name: '大事记',
          value: '大事记',
          icon: 'dashiji'
        },
        {
          name: '志书年鉴',
          value: '志书年鉴',
          icon: 'zhishunianjian'
        },
        {
          name: '白皮书',
          value: '白皮书',
          icon: 'baipishu'
        },
        {
          name: '文章著作',
          value: '理论文章、理论著作',
          icon: 'wenzhangzhuzuo'
        },
        {
          name: '新闻报道',
          value: '新闻报道',
          icon: 'xinwenbaodao'
        },
        {
          name: '典型人物',
          value: '典型人物',
          icon: 'dianxingrenwu'
        },
        {
          name: '课题报告',
          value: '课题报告',
          icon: 'ketibaogao'
        },
        {
          name: '专题片',
          value: '专题片',
          icon: 'zhuantipian'
        },
        {
          name: '出版物',
          value: '出版物',
          icon: 'chubanwu'
        },
        {
          name: '文艺作品',
          value: '文艺作品',
          icon: 'wenyizuopin'
        },
        {
          name: '电影',
          value: '电影',
          icon: 'dianying'
        },
        {
          name: '重大工程',
          value: '重大工程项目资料',
          icon: 'zhongdagongcheng'
        },
        {
          name: '个人作品',
          value: '个人作品',
          icon: 'gerenzuopin'
        },
        {
          name: '统计数据',
          value: '统计数据',
          icon: 'shudu'
        },
        {
          name: '重要实物',
          value: '实物资料',
          icon: 'zhongyaoshiwu'
        }
      ]
    }
  },
  methods: {
    selectType (item) {
      console.log(item)
      let routerData = this.$router.resolve({
        path: '/list',
        query: {
          ...this.$options.filters.keepURLParams(this),
          listCatalogName: item.value
        }
      })
      window.open(routerData.href, '_blank')
    }
  }
}
</script>

<style lang="stylus" scoped>
.type-list
  position absolute
  left 50%
  bottom 140px
  transform translate(-50%)
  width 80%
  min-height 92px
  padding 15px 10px
  box-sizing border-box
  background: #fff
  border-radius 4px
  box-shadow 0px 8px 27px 0px rgba(229, 222, 221, 0.71)

.type-item
  flex 1
  position relative
  cursor pointer
  color #CF1922

  .type-icon
    font-size 22px
    font-weight bold
    margin-bottom 13px

  .type-name
    white-space nowrap

.type-item:hover
  .type-name
    font-weight bold
    color #fff
    z-index 800

  .type-icon
    font-size 26px
    z-index 800
    color #fff

  &:after
    position absolute
    z-index 700
    top -32px
    content ''
    width 122px
    height 115px
    background-image url('~@/static/img/home/type-hover-bg.png')
    background-size 100% 100%
</style>
